import React from "react";
import { motion } from "framer-motion";
import { Mic2, Radar, Brain, Sparkles } from "lucide-react";

const STEPS = [
  { k: "01", t: "Speak", body: "Talk naturally. No prompts. No scripts.", icon: Mic2 },
  { k: "02", t: "Detect", body: "Voice, grammar, hesitation, intent — in real time.", icon: Radar },
  { k: "03", t: "Remember", body: "What mattered becomes a memory node.", icon: Brain },
  { k: "04", t: "Adapt", body: "Tomorrow's session loads your weak points.", icon: Sparkles },
];

const HowItWorks = () => {
  return (
    <section className="relative py-28 px-6" data-testid="section-how">
      <div className="max-w-7xl mx-auto">
        <div className="section-label">How sessions get smarter</div>
        <h2 className="headline mt-4 text-4xl sm:text-5xl lg:text-[72px] max-w-3xl">
          Speak. Detect. <em>Remember.</em> Adapt.
        </h2>

        <div className="mt-14 relative">
          <div className="hidden lg:block absolute top-[72px] left-10 right-10 h-px bg-gradient-to-r from-transparent via-aura-cyan/50 to-transparent" aria-hidden />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.k}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="relative glass rounded-3xl p-6 edge-glow overflow-hidden min-h-[200px]"
                data-testid={`how-step-${i}`}
              >
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 rounded-2xl grid place-items-center bg-aura-cyan/10 border border-aura-cyan/25 text-aura-cyan">
                    <s.icon size={18} strokeWidth={1.5} />
                  </div>
                  <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-whisper-muted">{s.k}</div>
                </div>
                <h3 className="mt-6 font-display text-[26px] font-light tracking-tight text-ink">{s.t}</h3>
                <p className="mt-2 text-whisper text-[14.5px] leading-[1.55]">{s.body}</p>
                <div className="mt-6 h-[3px] w-full rounded-full bg-panel/5 overflow-hidden">
                  <div className="h-full w-1/3 bg-gradient-to-r from-aura-cyan to-aura-blue rounded-full animate-shimmer"
                       style={{ backgroundSize: "200% 100%" }} />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
